<template>
    <div class="price-spec-row">
        <div class="price-spec-row-description">
            {{ description }}
            <ButtonLink v-if="readMore" :onClick="() => toggleModal()" size="m" type="button">
                {{ t({ key: 'shared.read_more' }) }}
            </ButtonLink>
        </div>

        <div class="price-spec-row-price">
            <span class="price" v-if="price" :class="classPrice">
                <span v-if="pricePrefix"> {{ pricePrefix }}</span>
                {{ getMoneyAsStringUsingCurrency(price.Amount, price.Currency) }}
            </span>

            <span v-if="subPrice" class="sub-price">
                ({{ getMoneyAsStringUsingCurrency(subPrice.Amount, subPrice.Currency) }}
                <span v-if="subDescription" class="ml-1">
                    {{ subDescription }}
                </span>
                )
            </span>
        </div>
        <Modal
            v-if="readMore && showModal"
            size="m"
            :title="readMore.title"
            :lockBody="false"
            :onClose="toggleModal">
            <div v-html="sanitize(readMore.description)" />
        </Modal>
    </div>
</template>

<script lang="ts">
    import { t } from '@shared/helpers/translation';
    import { defineComponent, PropType, ref } from 'vue';
    import { getMoneyAsStringUsingCurrency } from '@shared/helpers/money';
    import { Money } from '@libs/money/money.interfaces';
    import { sanitize } from '@shared/utils/sanitize';
    import ButtonLink from '@ui/components/Button/ButtonLink.vue';
    import Modal from '@ui/components/Modal/Modal.vue';

    interface ReadMore {
        title: string;
        description: string;
    }

    export default defineComponent({
        name: 'PriceSpecificationRow',
        methods: {
            getMoneyAsStringUsingCurrency,
            sanitize,
            t,
        },
        components: { Modal, ButtonLink },
        props: {
            description: { required: true, type: String },
            classPrice: { required: false, type: String },
            price: { required: true, type: Object as PropType<Money | null> },
            pricePrefix: { required: false, type: String },
            subPrice: {
                required: false,
                type: Object as PropType<Money | null>,
            },
            subDescription: { required: false, type: String },
            readMore: {
                required: false,
                type: Object as PropType<ReadMore | null>,
            },
        },
        setup() {
            const showModal = ref(false);
            const toggleModal = () => {
                showModal.value = !showModal.value;
            };

            return { showModal, toggleModal };
        },
    });
</script>

<style lang="scss">
    @forward '@/components/shared/PriceSpecification/PriceSpecificationRow';
</style>
